import React, { useState ,useEffect} from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { TwoFactorConfirmModal } from "./TwoFactorConfirmModal";
import { onRegenerateCode, onUserProfileLoad, TwoFactorAuthConfirmPassword } from "../../../store/Settings/actions";
import { QR } from "./QR";

export const TwoFactorAuthentication = () => {
    const [data, setData] = useState([]); 
    const [openModal, setOpenModal] = useState(false); 
    const [confirmPassword, setConfirmPassword] = useState("");
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [isRegenerate, setIsRegenerate] = useState(false);

    const {redirect, two_factor_authentication, is_two_factor_enabled} = useSelector(({settings}) => ({
        redirect: settings.redirect,
        two_factor_authentication: settings.user_profile.two_factor_authentication,
        is_two_factor_enabled: settings.user_profile.is_two_factor_enabled,
    }));

    useEffect(()=>{setData(two_factor_authentication)},[two_factor_authentication])    
    useEffect(()=>{redirect && dispatch(onUserProfileLoad())},[redirect])

    const onOpenModal = () => {setOpenModal((prev) => !prev)};
    const onCloseModal = () => {setOpenModal((prev) => !prev)};
    const handleConfirmPassword = (e) => {setConfirmPassword(e.target.value)};
    const regenerateHandle = () => {
        onOpenModal();
        setIsRegenerate(true)
    };

    const onSaveHandle = () => {
        if (isRegenerate) {
            dispatch(onRegenerateCode(confirmPassword))
        } else {
            dispatch(TwoFactorAuthConfirmPassword(confirmPassword));
        }                
        onCloseModal();
        setConfirmPassword("");
        setIsRegenerate(false)
    };

    return (
        <div className="rounded-lg shadow-md bg-white pt-5 pr-10 pb-4 pl-5 mb-6">
            <p className="font-bold text-base">
                {t("2-Factor Authentication")} -{" "}
                <span className="text-purple-600">{t("Recommended")}</span>{" "}
            </p>
            <p className="col-span-3 sm:col-span-3 py-3.5 text-xs text-gray-600">
                {t(
                    "Add extra security to your Cheqit account. A verification code will be required in addition to your password each time you sign in"
                )}
            </p>
            {is_two_factor_enabled? (
                <>
                    <p className="col-span-3 sm:col-span-3 py-3.5 text-xs text-gray-600">
                        {t(
                            "Two-Factor Authentication is now enabled. Scan the below QR code  using your phones authenticator application"
                        )}
                    </p>
                    <QR code={data?.qr_code}/>
                    <p className="col-span-3 sm:col-span-3 py-3.5 text-xs text-gray-600">
                        {t(
                            "Store these recovery codes in a secure password manager. They can be used to recover access to your account if your two factor authentication device is lost."
                        )}
                    </p>
                    <div className="col-span-3 text-xs text-gray-600 sm:col-span-3 px-2 py-3.5 mt-1 border-none focus:ring-gray-200 focus:border-gray-100 bg-gray-50 block w-full shadow-sm sm:text-sm rounded-md ">
                        {data?.recovery_codes?.map((code,index)=>(
                            <span key={index}><p className="mb-1 ml-2">{index +1}{" - "}{code}</p></span>
                        ))}
                    </div>

                    <div className="mt-14 py-2 px-1 flex justify-between">
                        <button
                            type="button"
                            className="inline-flex justify-center mr-2 py-2 px-2 whitespace-nowrap border border-transparent shadow-sm text-sm font-bold rounded-lg bg-gray-50 hover:bg-gray-200 focus:outline-none"
                            onClick={regenerateHandle}
                        >
                            {t("Regenerate Recovery Codes")}
                        </button>
                        <button
                            type="button"
                            onClick={onOpenModal}
                            className="inline-flex justify-center py-2 px-8 border border-transparent shadow-sm text-sm font-bold rounded-lg text-white bg-red-600 hover:bg-gray-700 focus:outline-none"
                        >
                            {t("Disable")}
                        </button>
                    </div>
                </>
            ) : (
                <div className="py-2 text-right">                    
                    <button
                        type="button"
                        onClick={onOpenModal}
                        className="inline-flex justify-center py-2 px-8 border border-transparent shadow-sm text-sm font-bold rounded-lg text-white bg-gray-900 hover:bg-gray-700 focus:outline-none"
                    >
                        {t("Enable")}
                    </button>  
                </div>
            )}
            <TwoFactorConfirmModal
                visible={openModal}
                onClose={onCloseModal}
                onSave={onSaveHandle}
                confirmPassword={confirmPassword}
                handleConfirmPassword={handleConfirmPassword}
            />
        </div>
    );
};
